import { EntityModel } from 'src/core/services/data/models';
import { DataService, property } from 'src/core/services/data.service';
import { BookemZulu as Model } from 'src/core/services/data/JayDataContext';

export class UserRoleDataService extends DataService<typeof Model.Core.Logic.ViewModels.Security.UserRoleSummary, Model.Core.Logic.ViewModels.Security.UserRoleSummary, UserRoleSummary> {
	protected map(entity: Model.Core.Logic.ViewModels.Security.UserRoleSummary): UserRoleSummary {
		return new UserRoleSummaryModel(entity);
	}

	static make(context?: any): UserRoleDataService {
		return new UserRoleDataService(context, ctx => ctx.UserRoleSummaries);
	}
	private id = -1;

	add(userId: number, roleId: number): Promise<UserRoleSummary> {
		const entity = new Model.Core.Logic.ViewModels.Security.UserRoleSummary();
		entity.userId = userId;
		entity.id = this.id--;

		return this.create(() => entity);
	}

	cleanEmptyAssignments() {
		const toDelete = [];
		for (let i = 0; i < this.items.length; i++) {
			if (this.items[i].roleId <= 0)
				toDelete.push(this.items[i]);
		}

		this.delete(toDelete);
	}
}

export class UserRoleSummaryModel extends EntityModel<Model.Core.Logic.ViewModels.Security.UserRoleSummary, UserRoleSummary> implements UserRoleSummary {
	@property<UserRoleSummaryModel>(o => o.entity.id, (o, value) => o.entity.id = value)
	public id: number;

	@property<UserRoleSummaryModel>(o => o.entity.displayName, (o, value) => o.entity.displayName = value)
	public displayName: string;

	@property<UserRoleSummaryModel>(o => o.entity.roleId, (o, value) => o.entity.roleId = value)
	public roleId: number;

	@property<UserRoleSummaryModel>(o => o.entity.userId, (o, value) => o.entity.userId = value)
	public userId: number;
}



// WEBPACK FOOTER //
// ./src/app/general/roles/parts/role-user-editor.data.ts